import {
  GET_PZ_VALIDATION_REQUEST_BY_ID,
  REMOVE_PZ_VALIDATION_REQUEST_FROM_REQUESTS,
} from "../actions/types";

const initialState = {
  pzValidationRequest: {},
};

const pzValidationRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PZ_VALIDATION_REQUEST_BY_ID:
      return {
        ...state,
        pzValidationRequest: action.payload,
      };
    case REMOVE_PZ_VALIDATION_REQUEST_FROM_REQUESTS:
      return {
        ...state,
        pzValidationRequest: {},
      };
    default:
      return state;
  }
};

export default pzValidationRequestReducer;
